import ifdValue from './ifdValue';
const parseTiff = {
    testff() {
        console.log("parse Tiff");
    },

    getFirstIFD(data) {
        try {
            var decoder = {
                offset: 0,
                data: undefined,
                littleEndian: true
            };
            /* decode header */
            decoder.offset = 0;
            var byteLength = data.byteLength - decoder.offset;
            let dvOffset = decoder.offset;
            decoder.data = new DataView(data, dvOffset, byteLength);
            decoder.littleEndian = true;

            // Read a 16 bit unsigned integer and move pointer forward by 2 bytes.
            ifdValue.getUInt16(decoder);

            //Check byte order
            if (decoder.value === 0x4949) {
                decoder.littleEndian = true;
            }
            else if (decoder.value === 0x4d4d) {
                decoder.littleEndian = false;
            }
            else {
                throw new Error(`invalid byte order: 0x${decoder.value.toString(16)}`);
            }

            ifdValue.getUInt16(decoder);
            // Magic number
            if (decoder.value !== 42) {
                throw new Error('not a TIFF file');
            }

            // Offset of the first IFD
            var _nextIFD = ifdValue.getUInt32(decoder);
            return _nextIFD;
            /* End of decode header */
        }
        catch (e) {
            console.log(e);
        }
    },

    parse(data, options = {}) {
        try {
            var decoder = {
                offset: 0,
                data: undefined,
                littleEndian: true
            };

            var size = {
                width: undefined,
                height: undefined
            }

            decoder.offset = 0;
            var byteLength = data.byteLength - decoder.offset;
            let dvOffset = decoder.offset;
            decoder.data = new DataView(data, dvOffset, byteLength);

            /* decode IFD */
            this.seek(decoder, 0);
            const numEntries = ifdValue.getUInt16(decoder);
            let ifd = {
                offset: undefined,
                tag: undefined,
                type: undefined,
                numValues: undefined
            }
            for (var i = 0; i < numEntries; i++) {
                const offset = decoder.offset;
                ifd.offset = decoder.offset;
                ifd.tag = ifdValue.getUInt16(decoder);
                ifd.type = ifdValue.getUInt16(decoder);
                ifd.numValues = ifdValue.getUInt32(decoder);

                if (ifd.type < 1 || ifd.type > 12) {      // It means that it is unknown type, skip this value
                    decoder.offset += 4;
                    return;
                }

                const valueByteLength = ifdValue.getByteLength(ifd.type, ifd.numValues);
                if (valueByteLength > 4) {
                    var Uint32 = ifdValue.getUInt32(decoder);
                    this.seek(decoder, Uint32);
                }

                if (ifd.tag === 256 || ifd.tag === 257) {       // If tag is width or height
                    const valueOfTag = ifdValue.readData(decoder, ifd.type, ifd.numValues);
                    if (ifd.tag === 256) {        // Width of tiff
                        size.width = valueOfTag;
                    }
                    if (ifd.tag === 257) {
                        size.height = valueOfTag;
                    }
                    if (size.width !== undefined && size.height !== undefined) {
                        return size;
                    }
                }

                this.seek(decoder, offset);
                decoder.offset += 12;
            }
        }
        catch (e) {
            console.log(e);
        }
    },
    seek(decoder, offset) {
        decoder.offset = offset;
    }

}

export { parseTiff as default }